import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';

import { extend } from '@syncfusion/ej2-base';
import { KanbanComponent, CardSettingsModel, ColumnsModel, DialogSettingsModel, SwimlaneSettingsModel, CardRenderedEventArgs } from '@syncfusion/ej2-angular-kanban';
import { cardData, kanbanData } from './data';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DemoService } from 'src/app/demo.service';
import { AppRoute } from 'src/app/shared/models/appRoute.model';

import { ContextMenuSettingsModel } from '@syncfusion/ej2-angular-diagrams';
import { DataUtil } from '@syncfusion/ej2-data';
import { addClass } from '@syncfusion/ej2-base';

@Component({
  selector: 'app-app-routes-diagram-kan-ban',
  templateUrl: './app-routes-diagram-kan-ban.component.html',
  styleUrls: ['./app-routes-diagram-kan-ban.component.scss']
})
export class AppRoutesDiagramKanBanComponent implements OnInit {


// setup as observable?
@Input() item_id?; // impliments on changes.
@Input() item_data?; // if data.model is sent : Observable<any[]>;
@Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
@Input() item_user_level_id? = '5'; // default to agent just in case
@Input() item_brand_type_id? = '';
@Input() show_buttons? = 'no'; // yes | no
@Input() widget_title? = '';
@Input() widget_size?; // side | abstract | full
@Input() current_field_name?;

@Input() promotion_id: number;
@Input() current_route: any;

search_model: AppRoute;
public contextMenuSettings: ContextMenuSettingsModel;

  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  new_data: any;
  array_of_routes: { }[];
  app_routes_metrix_search_full: Object;
  app_routes_metrix_search_full_results: any;

// Kan Ban Defauults
  @ViewChild('kanbanObj') kanbanObj: KanbanComponent;
  public kanbanData: Object[] = extend([], kanbanData, null, true) as Object[];
  public cardSettings: CardSettingsModel = {
      contentField: 'Summary',
      headerField: 'Id',
      tagsField: 'Tags',
      grabberField: 'Color',
      footerCssField: 'ClassName'
  };
  // end kan ban defaults



  // Kan Ban Full Overview
  // @ViewChild('kanbanObj') kanbanObj: KanbanComponent;
  // public kanbanData: Object[] = extend([], cardData, null, true) as Object[];
  // public columns: ColumnsModel[] = [
  //     { headerText: 'To Do', keyField: 'Open', allowToggle: true },
  //     { headerText: 'In Progress', keyField: 'InProgress', allowToggle: true },
  //     { headerText: 'In Review', keyField: 'Review', allowToggle: true },
  //     { headerText: 'Done', keyField: 'Close', allowToggle: true }
  // ];
  // public cardSettings: CardSettingsModel = {
  //     headerField: 'Title',
  //     template: '#cardTemplate',
  //     selectionType: 'Multiple'
  // };
  public dialogSettings: DialogSettingsModel = {
      fields: [
          { text: 'ID', key: 'Title', type: 'TextBox' },
          { key: 'Status', type: 'DropDown' },
          { key: 'Assignee', type: 'DropDown' },
          { key: 'RankId', type: 'TextBox' },
          { key: 'Summary', type: 'TextArea' }
      ]
  };
  public swimlaneSettings: SwimlaneSettingsModel = { keyField: 'Assignee' };
 // End Kan Ban Full Overview


  constructor(
    public gfunc: GlobalFunctionsService,
    private _demoService: DemoService,
    private router: Router,  private route: ActivatedRoute,
  ) {
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

   }



//Kan Ban Functions
public getString(assignee: string) {
  return assignee.match(/\b(\w)/g).join('').toUpperCase();
}
cardRendered(args: CardRenderedEventArgs): void {
  const val: string = (<{[key: string]: Object}>(args.data)).Priority as string;
  addClass([args.element], val);
}

// End kan Ban Functions


   ngOnInit(): void {
  }


   ngOnChanges(changes): void  {
 
    this.search_model = new AppRoute()

    if (changes.item_data) {
      this.new_data = changes.item_data.currentValue;
      // console.log('New Data Loaded: ', JSON.stringify(this.new_data));



                // Working function to filter and create an array Log Type Items - Triggers Exists in .. (system_automations_array)
                this.array_of_routes = [{
                  app_route_name: "Application Routes",
                  app_route_id: "parent",
                  // Role: "Site Map"
                }];
                // Count items of brand search to loop through
                let  count_of_trigger_items = Object.keys(this.new_data).length;
                // now loop and push to join model
                for(let i=0;i < count_of_trigger_items; i++) {
                  
                  // let res2 = this.new_data[i];
                  let res2 = this.new_data[i];

                  // var logs_type_triggers = JSON.parse(data[i].system_automation_array);
                    // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                    // if(logs_type_triggers.some(person => person == this.system_automation_id )){ } // end if exists in the current row array
              
                    if(res2.app_route_parent_id != 0 && res2.app_route_parent_id != null)
                    this.array_of_routes.push({
                  //  log_type_name: res2.log_type_name,
                  //  log_type_id: res2.log_type_id,
                  //  log_type_colour: res2.log_type_colour,
                  //  log_type_icon: res2.log_type_icon,
                  //  log_type_description: res2.log_type_description,
                  //  is_active: res2.is_active,
                      app_route_id: res2.app_route_id,
                      app_route_parent_id: res2.app_route_parent_id,
                      app_route_name: res2.app_route_name
                            });
                  if(res2.app_route_parent_id == 0 || res2.app_route_parent_id == null){
                    this.array_of_routes.push({
                          app_route_id: res2.app_route_id,
                          // app_route_parent_id: res2.app_route_parent_id,
                          app_route_name: res2.app_route_name
                                });
                  }

              
                          
                
                } // end app routes loop.
                
                this.array_of_routes = this.array_of_routes;


                // this.data_LOCAL_DATA_RECIEVED =  {
                //   id: 'app_route_id', parentId: 'app_route_parent_id', dataManager: new DataManager(this.array_of_routes),
                //   //binds the external data with node
                //   doBinding: (nodeModel: NodeModel, data: DataInfo, diagram_RADIAL_TREE_ONE: Diagram) => {
                //       nodeModel.annotations = [{
                //           /* tslint:disable:no-string-literal */
                //           content: data['app_route_name'], margin: { top: 10, left: 10, right: 10, bottom: 0 },
                //           style: { color: 'black' }
                //       }];
                //       /* tslint:disable:no-string-literal */
                //       nodeModel.style = { fill: '#ffeec7', strokeColor: '#f5d897', strokeWidth: 1 };
                //   }
                // };
          

                // this.snapSettings_ONE = {
                //     constraints: 0
                // }
                // this.items_ONE = new DataManager(this.array_of_routes as JSON[], new Query().take(7));
                // //Uses layout to auto-arrange nodes on the Diagram page
                // this.layout_ONE = {
                //     //Sets layout type
                //     type: 'HierarchicalTree'
                // }
                // //Configures data source for Diagram
                // this.dataSourceSettings_ONE = {
                //     id: 'app_route_id',
                //     parentId: 'app_route_parent_id',
                //     dataSource: this.items_ONE
                // }




    }

  }


    
  getAppRoutesSearchFull(search_model) {
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;
    this._demoService.getAppRoutesSearchFull(search_model).subscribe(
      data => { this.app_routes_metrix_search_full = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
        this.app_routes_metrix_search_full_results = DataUtil.parse.parseJson(data);
        // this.subject_service_metrix_search_full_results = data;
        this.new_data = this.app_routes_metrix_search_full_results.slice(0, 500);
  
        // const species: object[] = [
        //   { 'Name': 'Species', 'fillColor': '#3DD94A' },
        //   { 'Name': 'Plants', 'Category': 'Species' },
        //   { 'Name': 'Fungi', 'Category': 'Species' },
        //   { 'Name': 'Lichens', 'Category': 'Species' },
        //   { 'Name': 'Animals', 'Category': 'Species' },
        //   { 'Name': 'Mosses', 'Category': 'Plants' },
        //   { 'Name': 'Ferns', 'Category': 'Plants' },
        //   { 'Name': 'Gymnosperms', 'Category': 'Plants' },
        //   { 'Name': 'Dicotyledens', 'Category': 'Plants' },
        //   { 'Name': 'Monocotyledens', 'Category': 'Plants' },
        //   { 'Name': 'Invertebrates', 'Category': 'Animals' },
        //   { 'Name': 'Vertebrates', 'Category': 'Animals' },
        //   { 'Name': 'Insects', 'Category': 'Invertebrates' },
        //   { 'Name': 'Molluscs', 'Category': 'Invertebrates' },
        //   { 'Name': 'Crustaceans', 'Category': 'Invertebrates' },
        //   { 'Name': 'Others', 'Category': 'Invertebrates' },
        //   { 'Name': 'Fish', 'Category': 'Vertebrates' },
        //   { 'Name': 'Amphibians', 'Category': 'Vertebrates' },
        //   { 'Name': 'Reptiles', 'Category': 'Vertebrates' },
        //   { 'Name': 'Birds', 'Category': 'Vertebrates' },
        //   { 'Name': 'Mammals', 'Category': 'Vertebrates' }
        // ];

        // this.species = species

      //  this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );     
      }


// Get New App Notes and Collect Like I do with the Routes Bove... Do  matrix and search call so that I can have this sorted from to step go...

/*

// Build A simple UI to CRUD for APP Notes - Copy File Notes Grid....... (Module and then build from there.... ) -- now or after I KanBan actions and scheules happeing.


// Simple Model of Kan Ban Task -- need to convert my data over for App Notes.... 
  {
    'Id': 'Task 1',
    'Title': 'Task - 29001',
    'Status': 'Open',
    'Summary': 'Analyze the new requirements gathered from the customer.',
    'Type': 'Story',
    'Priority': 'Low',
    'Tags': 'Analyze,Customer',
    'Estimate': 3.5,
    'Assignee': 'Nancy Davloio',
    'RankId': 1,
    'Color': '#02897B',
    'ClassName': 'e-story, e-low, e-nancy-davloio'
  },
*/




}
